import { CheckoutPaymentMethod } from "../../PaymentMethod.ts";
import { PaymentMethodStepConfig } from "../PaymentMethodStepInterface.ts";
import { HeyLightPaymentStep } from "./HeyLightPaymentStep.tsx";
import HeyLightIcon from "/heylight_logo_black.svg";

export const HeyLightPaymentStepConfig: PaymentMethodStepConfig = {
  method: CheckoutPaymentMethod.HeyLight,
  StepComponent: HeyLightPaymentStep,
  isAvailableForItem: (item) => !!item.heylightConfig,
  icons: [
    <img src={HeyLightIcon} alt="HeyLight" className="w-12 text-gray-400" />,
  ],
};
